import type { TimedMetadataItem, TimedMetadataItemWithUsageRule } from '../dto/timedMetadataModels';
import type { TimedMdfUsageRule } from '../dto/timedMdfUsage';
import { RestrictedMaterialField } from '../mdf/MetaDataForm';

/**
 * Finds the usage rule matching key in 'usage_rule' mdf field and adds it to the timed mdf item
 */
export const addUsageRuleToTimedMetadataItems = (timedMetadata: TimedMetadataItem[], usageRules: TimedMdfUsageRule[] | undefined) => {
  if (usageRules) {
    for (const tm of timedMetadata) {
      const tmWithUsageRule = tm as TimedMetadataItemWithUsageRule;
      const usageRule = getUsageRuleFromTimedMdf(tm, usageRules);
      if (usageRule) tmWithUsageRule.usageRule = usageRule;
    }
  }
  return timedMetadata as TimedMetadataItemWithUsageRule[];
};


export const getUsageRuleFromTimedMdf = (timedMetadata: TimedMetadataItem, usageRules: TimedMdfUsageRule[]) => {
  const usageRuleKey = timedMetadata.data.formData[RestrictedMaterialField.UsageRule] as string;
  return usageRuleKey ? usageRules.find(rule => rule.identifier.key === usageRuleKey) : undefined;
};
